module.exports = __webpack_public_path__ + "src/assets/img/share/tips/open/b870d6436666a0c2596a9f75b857c14f.png";